import { createGlobalStyle } from "styled-components";
import { dalCustomColorsDark } from "./dalCustomColorsDark";

export const dalGlobalCSSDark = createGlobalStyle`
  body {
    font-family: "FFF AcidGrotesk";
        background-color: ${dalCustomColorsDark.darkPrimary};
  }
  
  h1, .h1 {
    font-family: "FFF AcidGrotesk";
    color: ${dalCustomColorsDark.headingsDark};
    font-size: 80px;
    font-weight: 700;
    line-height: 97px;
  } 
  
  h2, .h2 {
    font-family: "FFF AcidGrotesk";
    color: ${dalCustomColorsDark.headingsDark};
    font-size: 50px;
    font-weight: 700;
    line-height: 49px;
  }
  
  h3, .h3 {
    font-family: "FFF AcidGrotesk";
    color: ${dalCustomColorsDark.headingsDark};
    font-size: 24px;
    font-weight: 700;
    line-height: 29px;
  }
  
  p, .body1 {
    font-family: "FFF AcidGrotesk";
    color: ${dalCustomColorsDark.body1Dark};
    font-size: 16px;
    font-weight: 400;
    line-height: 27px;
  }
  
  .body1semibold {
    font-family: "FFF AcidGrotesk";
    color: ${dalCustomColorsDark.body1Dark};
    font-size: 16px;
    font-weight: 600;
    line-height: 27px;
  }
  
  .body2 {
    font-family: "FFF AcidGrotesk";
    color: ${dalCustomColorsDark.body2Dark};
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
  }
  
  .body2semibold {
    font-family: "FFF AcidGrotesk";
    color: ${dalCustomColorsDark.body2Dark};
    font-size: 14px;
    font-size: 12px;
    font-weight: 600;
    line-height: 20px;
  }

  .applicationCaption {
    font-family: "FFF AcidGrotesk";
    color: ${dalCustomColorsDark.captionGrey};
  }
  
  .caption {
    font-family: "FFF AcidGrotesk";
    color: ${dalCustomColorsDark.body1Dark};
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
  }

  .applicationDateChip {
    color: ${dalCustomColorsDark.body1Dark}; //TODO: If confirmed, put in shade of jobCategory
    background-color: ${dalCustomColorsDark.fieldBackgroundColor};
    border:  1px solid ${dalCustomColorsDark.borderColor};
  }

  .kanbanColumnHeader {
    background-color: ${dalCustomColorsDark.white};
  }

  .hrBotMultipleButton {
    background-color: ${dalCustomColorsDark.white};
    border-radius: 4px;
    border: 1px solid ${dalCustomColorsDark.borderColor};
    color: ${dalCustomColorsDark.primary};
  }

  .historyLine {
    border-bottom: 1px solid ${dalCustomColorsDark.borderColor}
  }

  .customNumberField {
    background-color: ${dalCustomColorsDark.fieldBackgroundColor};
    border-bottom: 1px solid ${dalCustomColorsDark.primary};
    border-top: 1px solid transparent;
    color: ${dalCustomColorsDark.primary};
  }

  .sideBar {
    border-right: 1px solid ${dalCustomColorsDark.borderColor};
    background-color: ${dalCustomColorsDark.fieldBackgroundColor};
  }

  .noteHeader {
    border-bottom: 1px solid ${dalCustomColorsDark.borderColor};
  }

  .disabled {
    opacity: 0.7;
  }

  .notification {
    border-bottom: 1px solid ${dalCustomColorsDark.primary};
  }

  .comment {
    border-bottom: 1px solid ${dalCustomColorsDark.borderColor};
  }
`;
